import type { CardInfo } from '@lub0v/santa-utils';
import { showToast } from '@src/components';
import i18n from '@src/i18n';

/** Full-list editors load their data only when the organizer opens them. */
export async function resolveActionCards(source: CardInfo[] | (() => Promise<CardInfo[]>)) {
  try { return typeof source === 'function' ? await source() : source; }
  catch { showToast(i18n.t('newBox.saveFailed')); return null; }
}
